<template>
  <button :style="buttonStyle" role="radio" :aria-checked="props.checked">
    <slot></slot>
  </button>
</template>

<script setup>
/* global defineProps */
import { computed } from 'vue';

const props = defineProps({
  color: {
    type: String,
    default: ''
  },
  checked: {
    type: Boolean,
    default: false
  }
});

const buttonStyle = computed(() => ({
  // 选中态高亮边框/背景/阴影
  fontWeight: '500',
  border: `2px solid ${props.checked ? props.color : '#d9d9d9'}`,
  background: props.checked ? props.color + '14' : '#fff',
  color: props.checked ? props.color : '#333',
  padding: '8px 14px',
  borderRadius: '20px',
  transition: 'all 0.15s ease',
  cursor: 'pointer',
  outline: 'none',
  boxShadow: props.checked ? `0 6px 18px ${props.color}22` : 'none',
  userSelect: 'none',
  margin: '0 8px',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center'
}));
</script>